import React from 'react';
import { Star, Medal, Heart, Clock } from '@phosphor-icons/react';

const iconMap = {
  star: Star,
  trophy: Medal,
  cake: Heart,
  clock: Clock,
};

const MilestonesSection = ({ milestones }) => {
  if (!milestones || milestones.length === 0) return null;

  return (
    <div className="card-elevated card-padding" data-testid="milestones-section">
      <h2 className="font-heading text-xl font-semibold mb-4 flex items-center gap-2">
        <Medal weight="duotone" className="w-5 h-5 text-[#C4A35A]" />
        Milestones
      </h2>
      <div className="flex flex-wrap gap-2">
        {milestones.map((m, idx) => {
          const MIcon = iconMap[m.icon] || Star;
          return (
            <div
              key={idx}
              className="flex items-center gap-2 bg-[#F9F8F5] border border-[#EAE8E3] rounded-xl px-3 py-2"
              data-testid={`milestone-${m.type}`}
            >
              <MIcon weight="duotone" className="w-4 h-4 text-[#C4A35A] flex-shrink-0" />
              <div>
                <p className="text-xs font-semibold text-[#1A1918]">{m.label}</p>
                {m.date && (
                  <p className="text-[10px] text-[#9A9590]">
                    {new Date(m.date).toLocaleDateString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric' })}
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MilestonesSection;
